import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export class InitialToMachineStructureDragAndDropHandler {
  initialToMachineStructureDragAndDrop(targetNode) {
    const initialStructureNodeset = getInitialStructureNodeset();
    const machineStructureNodeset = getMachineStructureNodeset();

    machineStructureNodeset.initialToMachineDragAndDrop(
      initialStructureNodeset,
      machineStructureNodeset,
      targetNode,
    );
  }
}
